import { render, staticRenderFns } from "./maternity.vue?vue&type=template&id=49c544fa&scoped=true"
import script from "./maternity.vue?vue&type=script&lang=js"
export * from "./maternity.vue?vue&type=script&lang=js"
import style0 from "./maternity.vue?vue&type=style&index=0&id=49c544fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c544fa",
  null
  
)

export default component.exports